/**
 * EmptyState - what to show when a list has nothing in it.
 *
 *   <EmptyState icon={Inbox} title="No chores yet" message="..." action={<Link .../>} />
 */
import { Inbox } from 'lucide-react';

export default function EmptyState({ icon: Icon = Inbox, title, message, action = null }) {
  return (
    <div className="empty-state">
      <Icon size={40} className="empty-icon" aria-hidden="true" />
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {action && <div style={{ marginTop: 'var(--space-sm)' }}>{action}</div>}
    </div>
  );
}
